const translations = {
  en: {
    collapse_close: 'Expand rotation',
    collapse_open: 'Collapse rotation',
    help: 'Help',
    helpReset: 'Reset rotation to 0°',
    helpRotateLeft: 'Rotate 90° counter-clockwise',
    helpRotateRight: 'Rotate 90° clockwise',
    helpSlider: 'Fine-tune rotation angle (-180° to 180°)',
    helpTitle: 'Rotation Controls',
    hide: 'Hide rotation',
    init: 'Init',
    progress: 'Show angle',
    revert: 'Revert',
    rotateLeft: 'Rotate 90° left',
    rotateRight: 'Rotate 90° right',
    show: 'Show rotation',
  },
  ja: {
    collapse_close: '回転を開く',
    collapse_open: '回転を畳む',
    help: 'ヘルプ',
    helpReset: '回転を0°にリセット',
    helpRotateLeft: '反時計回りに90度回転',
    helpRotateRight: '時計回りに90度回転',
    helpSlider: '回転角度を微調整（-180°〜180°）',
    helpTitle: '回転コントロール',
    hide: '回転を隠す',
    init: '初期化',
    progress: '角度を表示',
    revert: 'リセット',
    rotateLeft: '左に90度回転',
    rotateRight: '右に90度回転',
    show: '回転を表示',
  },
};

export default translations;
